import { default as React } from 'react';
import MedicationsNotFound from '../../Images/medicationsNotFound.svg';
import styles from './NoResults.module.scss';

export const NoResults: React.FC<{
    title: React.ReactNode;
    info?: string;
}> = props => {
    return (
        <div className={styles.placeholder}>
            <div className={styles.placeholderContent}>
                <img src={MedicationsNotFound} alt='nothing-found' />
                <div className={styles.placeholderTitleText}>{props.title}</div>
                {props.info && <div className={styles.placeholderText}>{props.info}</div>}
            </div>
        </div>
    );
};
